import { useController, useFormContext } from 'react-hook-form';
// eslint-disable-next-line import/no-named-as-default-member
import InputComponent from './component';

const Input = ({
  name,
  required = false,
  defaultValue = false,
  ...restProps
}) => {
  const { control } = useFormContext() || {};

  const {
    field: { ref, ...inputProps },
    fieldState: { error, isDirty },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue,
  });

  return (
    <InputComponent
      {...inputProps}
      {...restProps}
      error={error}
      required={required}
      name={name}
      isDirty={isDirty}
      inputRef={ref}
    />
  );
};

export default Input;
